import { createQueryKeys } from "@lukemorales/query-key-factory";

import { createServiceResponseSchema, privateApi } from "@/api/axios";
import { progressResponseSchema } from "@/domains/progress/models/schemas";

export const progressQueryOptions = createQueryKeys("progress", {
  current: {
    queryKey: null,
    queryFn: () => {
      return getProgress();
    },
  },
});

export const getProgress = async () => {
  const response = await privateApi.get("/progress");

  return createServiceResponseSchema(progressResponseSchema).parse(response.data).data;
};
